import { mutate } from "swr";
import { logger } from "@helpers/logger";

/**
 * Publishes peripheral changes to Redis for real-time synchronization.
 * Shared across monetics, printer, and peripheral association hooks.
 */
export async function redisPublishPeripheral(
    shopIds: string[],
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
): Promise<void> {
    const redisApiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/peripheral/redis`;
    await Promise.all(
        shopIds.map(async (shopId: string) => {
            try {
                const data: any = await fetchGlobal<any>(redisApiUrl, {
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ shopId }),
                    method: "POST",
                });
                mutate(redisApiUrl, data);
                if (data.error) {
                    throw Error("Error while saving selection!");
                }
            } catch (e: any) {
                logger.error("Redis publish error for shop:", shopId);
            }
        })
    );
}
